export const ENVIRONMENT_MODE = process.env.REACT_APP_ENVIRONMENT;

export const URL_CONFIG = {
    API: {
        url: process.env.REACT_APP_API_URL
    },
    SOCKET: {
        url: process.env.REACT_APP_SOCKET_URL
    }
};

export const ENV_CLIENT_ID = {
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    googleClientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
    lineClientId: process.env.REACT_APP_LINE_CLIENT_ID,
    lineAuthUrl: process.env.REACT_APP_LINE_AUTH_URL,
    lineClientSecret: process.env.REACT_APP_LINE_CLIENT_SECRET,
    redirectUrl: process.env.REACT_APP_REDIRECT_URL,
    xClientId: process.env.REACT_APP_X_CLIENT_ID,
    xClientSecret: process.env.REACT_APP_X_CLIENT_SECRET
};
